module.exports = __webpack_public_path__ + "media/application/images/ui/menu-table-active-1f71952f1f2dcae205e49df2c04582c5.svg";